import { RESERVATION_STATUS } from './reservation-status.type';

export const RESERVATION_URL = 'reservation';

export const RESERVATION_STATUSES_LABELS: Record<RESERVATION_STATUS, string> = {
  REQUESTED: 'En attente',
  CONFIRMED: 'Confirmée',
  SEATED: 'Installée',
  HONORED: 'Honorée',
  NO_SHOW: 'Non présentée',
  CANCELLED: 'Annulée',
  REJECTED: 'Refusée',
};

export const RESERVATION_STATUSES: RESERVATION_STATUS[] = [
  'REQUESTED',
  'CONFIRMED',
  'SEATED',
  'HONORED',
  'NO_SHOW',
  'CANCELLED',
  'REJECTED',
];

export const RESERVATION_ERROR_MESSAGES: Record<string, string> = {
  reservations_not_accepted_by_shop: 'Les réservations ne sont pas activées pour ce restaurant.',
  reservation_place_not_found: "Cette adresse n'appartient pas au restaurant.",
  reservation_slot_outside_opening_hours: "Ce créneau ne correspond pas aux horaires d'ouverture.",
  reservation_lead_time_not_respected: 'Ce créneau est trop proche pour être réservé en ligne.',
  reservation_too_far_ahead: 'Ce créneau est trop lointain pour être réservé en ligne.',
  reservation_guest_count_too_high: 'Ce nombre de couverts dépasse le maximum accepté en ligne.',
  reservation_slot_full: 'Plus assez de couverts disponibles sur ce créneau.',
  invalid_reservation_key: 'Ce lien est invalide ou a expiré.',
  invalid_reservation_status_change: 'Cette réservation ne peut plus être modifiée dans son état actuel.',
  reservation_reconfirmation_not_allowed: 'Seule une réservation confirmée peut faire l’objet d’une confirmation.',
  reservation_cancellation_too_late: 'Le délai d’annulation en ligne est dépassé.',
  reservation_not_found: 'Cette réservation est introuvable.',
  reservation_does_not_belong_to_shop: "Cette réservation n'appartient pas à ce restaurant.",
};

export const DEFAULT_RESERVATION_ERROR_MESSAGE = 'Une erreur est survenue, veuillez réessayer.';

export const ANONYMOUS_PRINCIPALS = ['anonymousUser', 'anonymous'];
